import React, { useEffect, useState ,useRef } from 'react';
import {
    Card,
    Form,
    Input,
    Button,
    Upload,
    Divider,
    Radio,
    Row,
    Col,
    message,
    Modal,
    Collapse,
    Avatar,
    Checkbox,
    Select,
    Tooltip,
    List,
    Typography,
  Progress,
  Spin
} from 'antd';
import {
    UploadOutlined,
    LoadingOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    ClearOutlined,
    LeftOutlined,
} from '@ant-design/icons';
import './index.css';
import {
    uploadImgRequest,
    createKcsFileList,
    updateImgCaption,
    getDatasetsFileProcess
} from './api';
import styles from "../CreactApp/create.module.css";
import { createKcs } from "../createZhishikuDialog/api";
import { API_URL } from '../../../../util/constants';
import Cookies from 'js-cookie';

const { Panel } = Collapse;
const { Meta } = Card;
const { Option } = Select;
// const API_URL = 'http://ygbhpy.gamepku.com';
const { TextArea } = Input;
const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
};

const ImgPage = (props) => {
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
      const [loading, setLoading] = useState(false);
      const [imageUrl, setImageUrl] = useState();
      const [iconImg, setIconImg] = useState('');
      const [iconImgName, setIconImgName] = useState('');
      const [fileList, setFileList] = useState([]);

      const [dataset_id, setDataset_id] = useState(props.id);
      const [captionInfo, setCaptionInfo] = useState('');

      const [progress, setProgress] = useState(0);
      const [isLoading, setIsLoading] = useState(false);

      const [remainTime, setRemainTime] = useState(``);
      const intervalRef = useRef(null);

  useEffect(() => {
    // 组件卸载时清理定时器
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []); // 空数组意味着这个 effect 只会在组件挂载时执行一次

  const onCancelImgPage = () => {
    props.onCancelImgPage();
  };

  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      // 生成新文件名（可根据需求修改）
      const fileExt = file.name.substr(file.name.lastIndexOf('.') + 1);
      const newFileName = `img_${Date.now()}_${Cookies.get('user_login')}.${fileExt}`;

      // 调用你的上传接口
      await uploadImgRequest(file, newFileName, (data) => {
        if (data.ret == 1) {
          // const fileUrl = `${API_URL}/icons/${newFileName}`;
          // onSuccess({ ...file, url: fileUrl }, file);
          // onUploadSuccess?.(fileUrl); // 可选：通知父组件上传成功
          file.url = API_URL + '/icons/' + newFileName;
          // file.name = newFileName
          onSuccess(file);
          console.log(data)
          setIconImg(data.imgInfo.id);
          setIconImgName(data.imgInfo.file_name);
        } else {
          onError(data);
          message.error('上传失败: ' + (data.message || '未知错误'));
        }
      });
    } catch (error) {
      onError(error);
      message.error('上传失败: ' + error.message);
    }
  };

  const handleChange = (info) => {
    console.log(info, 'info');
    if (info.fileList.length == 2) {
      setFileList([info.fileList[1]]);
    } else {
      setFileList(info.fileList);
    }
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: 'none',
      }}
      type='button'
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
    </button>
  );

  const beforeUpload = (file) => {
    const isImage =
      file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
    if (!isImage) {
      message.error('只支持 JPG/JPEG/PNG 格式的图片');
    }

    return isImage;
  };

  const changeCaptionInfo = (e) => {
    setCaptionInfo(e.target.value);
  };

    return (

      <Modal
        maskClosable={false}
        title='新增知识库'
        okText='确认'
        cancelText='取消'
        onCancel={onCancelImgPage}
        onOk={() => {
          form.validateFields()
            .then((values) => {

              if (iconImg) {

                setIsLoading(true);

                createKcsFileList( {
                    dataset_id: dataset_id,
                    format_type: 2,
                    document_bases: [
                      {
                        "name": iconImgName,
                        "source_info": {
                          "source_file_id": iconImg,
                          "document_source": 5
                        }
                      }
                    ],
                    chunk_strategy: {
                      "caption_type": 0
                    }
                  },
                  (res) => {
                    if (res.ret == 1) {
                      console.log(res)

                      var document_id = res.data[0].document_id;

                      // 定义轮询函数
                      const fetchProgress = async () => {
                        try {
                          // 替换为实际的 API 调用
                          const ids = [];
                          ids.push(document_id);

                          getDatasetsFileProcess(dataset_id,ids,
                            (res) => {
                              if (res.ret == 1) {
                                console.log(res)
                                setProgress(res.data[0].progress);
                                const totalSeconds = res.data[0].remaining_time;
                                const minutes = Math.floor(totalSeconds / 60);
                                const seconds = totalSeconds % 60;
                                const time = `${minutes}分钟${seconds}秒`;
                                console.log(`${minutes}分钟${seconds}秒`);
                                setRemainTime(time)
                                if(res.data[0].progress>= 100){
                                  clearInterval(intervalRef.current);
                                  setIsLoading(false);

                                  updateImgCaption({
                                      dataset_id: dataset_id,
                                      document_id:document_id,
                                      caption:captionInfo
                                    },
                                    (res) => {
                                      if (res.ret == 1) {
                                        console.log(res)
                                        //message.success('修改标注成功');
                                        message.success('知识库文件创建成功');
                                        onCancelImgPage()
                                      }else{
                                        message.error('操作失败');
                                      }
                                    })
                                }
                              }else{

                              }
                            });


                        } catch (err) {
                          if (intervalRef.current) {
                            clearInterval(intervalRef.current);
                          }
                          setIsLoading(false);
                        }
                      };

                      // 立即执行一次获取初始进度
                      fetchProgress();
                      // 设置定时器轮询
                      intervalRef.current = setInterval(fetchProgress, 2000);


                      // setTimeout(() => {

                      //   updateImgCaption({
                      //       dataset_id: dataset_id,
                      //       document_id:document_id,
                      //       caption:captionInfo
                      //     },
                      //     (res) => {
                      //       if (res.ret == 1) {
                      //         console.log(res)
                      //         message.success('修改标注成功');
                      //       }else{
                      //         message.error('操作失败');
                      //       }
                      //     })
                      //
                      // }, 8000);



                    }else{
                      message.error('操作失败');
                    }
                  })
              }else{
                message.error('请上传图片');
              }

            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
        visible={true}>

        <Form
          form={form}
          layout='vertical'
          initialValues={{
            name: '',
            description: '',
            prompt: '0',
          }}
        >

        <div
          className={styles.title}
          style={{marginTop:10,marginBottom:10}}
        >
          1.上传图片<div style={{color:'red',marginLeft:2}}>※</div>
        </div>

        <Upload
          fileList={fileList}
          name='avatar'
          listType='picture-card'
          className='avatar-uploader'
          beforeUpload={beforeUpload}
          onChange={handleChange}
          customRequest={customRequest}
          showUploadList={true}
        >
          {/* {imageUrl ? (
                                            <img
                                                src={imageUrl}
                                                alt='avatar'
                                                style={{
                                                    width: '100%',
                                                }}
                                            />
                                        ) : (
                                            uploadButton
                                        )}*/}
          {fileList.length >= 1? null :
            // <Button type="primary" icon={<UploadOutlined/>}>
            //     上传文件
            // </Button>
            (uploadButton)
          }

        </Upload>
        <div style={{ marginTop: 8 }}>支持 JPG，JPEG，PNG，每个文件不超过10 MB</div>


        <div
          className={styles.title}
          style={{marginTop:10,marginBottom:10}}
        >
          2.人工标注<div style={{color:'red',marginLeft:2}}>※</div>
        </div>

        <Form.Item
          label=''
          name='name'
          rules={[
            { required: true, message: '请输入图片的描述信息' },
            { max: 2000, message: '不能超过2000个字符' },
          ]}
        >
          <TextArea

            style={{ height: 150,
              verticalAlign: 'top'}}
            placeholder='请输入图片的描述信息'
            maxLength={2000}
            showCount={{
              formatter: ({ count }) => `${count}/2000`,
            }}
            onChange={changeCaptionInfo}
            value={captionInfo}
          />
        </Form.Item>

        </Form>

        {isLoading?
          <div className='div-progress'>
            <Progress percent={progress}
                      format={(percent) => (
                        <span className="percent">{percent}%</span>)}/>
            <div className='time'>剩余时间：{remainTime}</div>
          </div>
          :null}


        {isLoading?
          <Spin
            size="large"
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1000
            }}/>:null}


      </Modal>
    );
};

export default ImgPage;
